module.exports = __webpack_public_path__ + "img/0Q3B3739_WoodMatted_MockedUp.4cf44b18.jpg";